<template>
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <slot />
        </div>
        <div class="mt-6">
            <slot name="under" />
        </div>
    </div>
</template>

<script lang="ts" setup></script>
